<template>
  <div slot="settings" class="dialog">
    <ul class="dialog__list">
      <li>
        <!--
        <span href="#" @click="$event.preventDefault()">
          <dropdown :visible="visibleNested" :animation="animation" :position="positionNested" @clickout="visibleNested = false">
            <div class="dialog__item" @mouseover="visibleNested = true" @click="visibleNested = true">
              <font-awesome-icon :icon="icon.download" class="dialog__category-icon" />
              <span class="dialog__item-text">{{ $t('topbarSettings.download') }}</span>
              <icon-arrow-right class="dialog__subnav-icon" />
            </div>
            <div slot="dropdown" class="dialog" >
              <ul class="dialog__list">
                <li>
                  <span href="#" class="dialog__item">
                    <span class="dialog__item-text">PDF</span>
                  </span>
                </li>
                <li>
                  <span href="#" class="dialog__item">
                    <span class="dialog__item-text">XLS</span>
                  </span>
                </li>
                <li>
                  <span href="#" class="dialog__item">
                    <span class="dialog__item-text">CSV</span>
                  </span>
                </li>
                <li>
                  <span href="#" class="dialog__item">
                    <span class="dialog__item-text">PNG</span>
                  </span>
                </li>
              </ul>
            </div>
          </dropdown>
        </span>
      </li>
      -->
      <!-- If has nested menu like the example of above the <span> element of the <li> must have: -->
      <!-- @mouseover="visibleNested = false -->
      <li>
        <span href="#" class="dialog__item clickable" @click="emitEvent('onClickCopy')">
          <font-awesome-icon class="dialog__category-icon" :icon="icon.copy" />
          <span class="dialog__item-text">{{ $t('topbarSettings.copy') }}</span>
        </span>
    </li>
      <li v-has-feature="'Query'">
        <span v-has-route="'/query/list'" href="#" class="dialog__item clickable" @click="emitEvent('onClickSave')">
          <font-awesome-icon class="dialog__category-icon" :icon="icon.save" />
          <span class="dialog__item-text">{{ $t('explorer.queryModal.title') }}</span>
        </span>
      </li>
      <li>
        <span href="#" class="dialog__item clickable" @click="emitEvent('onClickDownload')">
          <font-awesome-icon class="dialog__category-icon" :icon="icon.csvFile"/>
          <span class="dialog__item-text">{{ $t('topbarSettings.downloadCSV') }}</span>
        </span>
      </li>
      <!--
      <li>
        <span href="#" class="dialog__item" @mouseover="visibleNested = false">
          <font-awesome-icon class="dialog__category-icon" :icon="envelope" />
          <span class="dialog__item-text">{{ $t('topbarSettings.send') }}</span>
        </span>
      </li>
      -->
    </ul>
  </div>
</template>

<script>
import {eventBus} from '@/main';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faSave, faCopy, faFileCsv} from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'ExplorerTopbarSettings',
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      icon: {
        copy: faCopy,
        save: faSave,
        csvFile: faFileCsv
      }
    };
  },
  methods: {
    emitEvent (eventName) {
      this.$emit(eventName);
      eventBus.$emit('closeSettings');
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/explorer/ExplorerTopbarSettings.vue